import React from 'react';
import { Badge, SpaceBetween } from '@cloudscape-design/components';
import { SourceSopLabels } from 'src/contstant/commonLabels';

interface DocLinkTitleProps {
  /** The link's display title. */
  title?: string;
  /** Whether this link is the source SOP its question was generated from. */
  isSourceSop: boolean;
}

/**
 * A doc link's title for the V1 question views, with a "Source SOP" badge when
 * the link is the source SOP (system-attached provenance, not author-added).
 * Shared by the edit wizard's links table and the question details page.
 */
const DocLinkTitle: React.FC<DocLinkTitleProps> = ({ title, isSourceSop }) => {
  if (!isSourceSop) return <>{title}</>;
  return (
    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
      <span>{title}</span>
      <Badge color="blue" data-testid="source-sop-badge">
        {SourceSopLabels.BADGE}
      </Badge>
    </SpaceBetween>
  );
};

export default DocLinkTitle;
